<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap>
        <v-flex xs12 sm12 md10>
          <v-card>
            <v-card-title color="" class="py-1">
              Laboratory Tests
              <v-spacer></v-spacer>
              <v-text-field label="Search" v-model="filterBy" prepend-inner-icon="search" dense placeholder="Search ..."></v-text-field>
              <v-spacer></v-spacer>
              <v-btn small @click="addTests = !addTests" outlined text color="primary">Add</v-btn>
            </v-card-title>
            <v-card-text>
              <view-lab-tests :tests="laboratory_tests" :laboratories="laboratories" :search="filterBy"></view-lab-tests>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click.stop.prevent="goTo('/laboratories')" href="/laboratories">Lab Providers</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 sm12 md2 class="pt-10">
          <p>
            <v-btn text @click.stop.prevent="goTo('/laboratories')" href="/laboratories">Lab Providers</v-btn>
          </p>
        </v-flex>
      </v-layout>
      <modal-dialog :open="addTests" @close="addTests = false">
        <template #title>Add Laboratory Test</template>
        <add-lab-test :laboratories="laboratories"></add-lab-test>
      </modal-dialog>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'
  const ViewLabTests = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "labtests" */ '@/Components/Labtests/index')
  const AddLabTest = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "labtests" */ '@/Components/Labtests/create')
  const ModalDialog = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/dialog')

  export default {
    name: 'LaboratoryTests',
    components: {
      ViewLabTests,
      AddLabTest,
      ModalDialog,
    },
    layout,
    props: [
      'laboratory_tests',
      'laboratories'
    ],
    metaInfo () {
      return {
        title: 'Laboratory Tests',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        addTests: false,
        filterBy: '',
      }
    },
  }
</script>
